import { h, render, Fragment } from 'preact';
import { useState, useEffect, useCallback } from 'preact/hooks';
import Storefront from '../utils/storefront';
import { collectionByIdWithProductCursor } from '../utils/storefront/queries';
import CollectionGrid from '../collection/collection-grid';
import Intersection from '../Intersection';
import { getProductsForCard } from '../utils/helpers';
import { formatProducts } from '../utils/storefront/format-resource';

const storefront = new Storefront();

export default (element, data) => {
  const CollectionGridWrapper = () => {
    const [collection, setCollection] = useState();
    const [products, setProducts] = useState([]);
    const [cursor, setCursor] = useState();
    const [nextPageCursor, setNextPageCursor] = useState();

    const encodedCollectionId = window.btoa(
      `gid://shopify/Collection/${data.collectionId}`,
    );

    const fetchCollectionProducts = useCallback(async (id, cursor) => {
      const response = await storefront.request({
        query: collectionByIdWithProductCursor,
        variables: { id, cursor },
      });

      const { endCursor, hasNextPage } =
        (await response?.data?.node?.products?.pageInfo) || {};

      if (!hasNextPage) return { hasNextPage };

      const { products, ...collectionData } = response?.data?.node || {};
      const formattedProducts = getProductsForCard(
        formatProducts(products?.edges || []),
      );

      return {
        collection: collectionData,
        products: formattedProducts,
        endCursor,
        hasNextPage,
      };
    }, []);

    const nextPage = useCallback(
      async (cursor) => {
        setCursor(cursor);

        const { endCursor, hasNextPage, products, collection } =
          await fetchCollectionProducts(encodedCollectionId, cursor);

        if (!products?.length) return;
        if (hasNextPage) setNextPageCursor(endCursor);

        setCollection(collection);
        setProducts((prev) => [...prev, ...products]);
      },
      [encodedCollectionId, fetchCollectionProducts],
    );

    useEffect(() => {
      nextPage();
    }, [nextPage]);

    const handleIntersect = useCallback(() => {
      if (nextPageCursor && nextPageCursor !== cursor) {
        nextPage(nextPageCursor);
      }
    }, [cursor, nextPage, nextPageCursor]);

    return (
      <>
        {products?.length > 0 && (
          <CollectionGrid
            collectionProducts={products}
            headerMetafields={collection?.headerMetafields}
            title={collection?.title}
            description={collection?.descriptionHtml}
            contentBlocks={data.contentBlocks}
            isSearchPage
          />
        )}
        <Intersection onIntersect={handleIntersect} />
      </>
    );
  };

  const init = async () => {
    render(<CollectionGridWrapper />, element);
  };

  init();
};
